import BasicLayout from '@/layouts/basic-layout'

const prefix = 'accounts-receivable-statement-'
export default {
  path: '/report-center/accounts-receivable-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {cache: true, title: '应收报表'},
      component: () => import('@/pages/report-center/accounts-receivable-statement/index')
    },
  ]
}
